import Typography from "@mui/material/Typography";
import {GenreSelectorMultiple} from "@/components/bandcreate/GenreSelectorMultiple";
import CheckboxStyled from "@/components/CheckboxStyled";
import InputLabelStyled from "@/components/InputLabelStyled";
import Box from "@mui/material/Box";

const NetworkLocationFormPlattenvertriebe = ({onChange}) => {

    const handleInputChanged = (event, value) => {
        if (onChange && typeof onChange === "function") {
            onChange(event, value);
        }
    }

    const handleCheckboxChanged = (event) => {
        event.target.value = event.target.checked;

        if (onChange && typeof onChange === "function") {
            onChange(event);
        }
    };

    return (
        <>
            <Typography variant="h4" component="p" color="common.black" sx={{mt: 4,}}>
                Orts-spezifische Angaben (Plattenvertriebe)
            </Typography>
            <GenreSelectorMultiple
                label="Genre *"
                hint="Wähle bis zu vier"
                onChange={handleInputChanged}
                maxCount="4"
            />
            <Box sx={{mt: 1,}}>
                <InputLabelStyled label="Bitte auswählen"/>
                <CheckboxStyled
                    label="Tonträger physisch"
                    name="medium_physical"
                    onChange={handleCheckboxChanged}
                    marginTop
                />
                <CheckboxStyled
                    label="Tonträger digital"
                    name="medium_digital"
                    onChange={handleCheckboxChanged}
                    marginTop
                />
            </Box>
        </>
    )
}

export default NetworkLocationFormPlattenvertriebe;
